import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import theme from '@/theme';
import styled from '@emotion/styled';
import { ElementsSection } from 'polotno/side-panel';
import { StyledText } from '../common/SectionTitle';

const ShapesPanelContainer = styled.div`
    padding: 20px !important;
    height: 100%;
    overflow: hidden;
    gap: 12px;
    display: flex;
    flex-direction: column;

    img {
        // black color for shapes
        filter: brightness(0) saturate(100%);
    }
`;

const PolotnoStyleWrapper = styled.div`
    height: calc(100% - 35px);
    // search bar
    .bp5-input-group {
        display: none;
    }

    // titles for sections
    p {
        display: none;
    }

    & > div > div:nth-child(2) {
        display: flex;
        flex-direction: column;
        gap: 8px;

        // lines container
        & > div:nth-of-type(1) {
            height: unset;

            // lines sub container
            > div {
                display: flex;
                gap: 8px;

                // lines column
                > div {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    width: calc(33% - 5px) !important;
                }
            }

            .polotno-close-panel {
                background: ${theme.colors.black[100]};
                border-radius: 8px;
                width: 100%;
                padding: 16px;
                aspect-ratio: 1;
                display: flex;
                align-items: center;

                img {
                    height: unset !important;
                }

                :hover {
                    outline: 2px solid ${({ theme }) => theme.colors.primary.main};
                    outline-offset: -3px;
                }
            }
        }

        // shapes container
        & > div:nth-of-type(2) {
            height: unset !important;

            // shapes sub container
            > div {
                display: flex;
                flex-direction: column;
                gap: 8px;

                // shapes columns
                > div {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    width: 100% !important;
                    gap: 8px;
                    //background: red;

                    > div:nth-child(3n + 1):nth-last-child(1),
                    > div:nth-child(3n + 1):nth-last-child(2),
                    > div:nth-child(3n + 2):nth-last-child(1) {
                        display: none;
                    }
                }
            }

            // single shape tile
            .polotno-close-panel {
                background: ${theme.colors.black[100]};
                border-radius: 8px;
                width: calc(33% - 5px);
                padding: 16px;

                img {
                    height: unset !important;
                }

                :hover {
                    outline: 2px solid ${({ theme }) => theme.colors.primary.main};
                    outline-offset: -3px;
                }
            }
        }
    }
`;

export const ShapesList = () => {
    const { store } = useAdvancedEditorContext();

    return (
        <ShapesPanelContainer data-testid="shapes-list-panel">
            <StyledText>Shapes</StyledText>

            <PolotnoStyleWrapper>
                <ElementsSection.Panel store={store} />
            </PolotnoStyleWrapper>
        </ShapesPanelContainer>
    );
};
